export default {
  computed: {
    pageTitle() {
      return this.$store.state.website.page.title
    },
    pageKeywords() {
      return this.$store.state.website.page.keywords
    },
    pageDescription() {
      return this.$store.state.website.page.description
    },
    twitterImage() {
      if (this.$store.state.betterme === 'bettermeedu') {
        return 'https://download-pa-s3.thethinkacademy.com/frontend/2025/02/20/7fguiwsgoj.png'
      }
      return 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/common/brand-logo-square.jpg'
    },
    applicationName() {
      if (this.$store.state.betterme === 'bettermeedu') {
        return 'Better Me';
      }
      return 'Think Academy';
    },
  },
  head() {
    const defaultTitle = this.$t('common.websiteName');
    let baseUrl = ''
    // 服务端：从请求头中获取当前域名
    if (process.server && this.$req) {
      // 获取协议（http/https）
      const protocol = this.$req.headers['x-forwarded-proto'] || 'http'
      // 获取主机名（含端口）
      const { host } = this.$req.headers
      baseUrl = `${protocol}://${host}`
    }
    // 客户端：从当前窗口获取域名
    if (process.client) {
      baseUrl = window.location.origin
    }
    return {
      title: this.pageTitle || defaultTitle,
      meta: [
        {
          name: 'keywords',
          content: this.pageKeywords,
        },
        {
          name: 'description',
          content: this.pageDescription,
        },
        // 添加Twitter相关元标签
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:title',
          content: this.pageTitle || defaultTitle,
        },
        {
          name: 'twitter:description',
          content: this.pageDescription || this.$t('seo.description'),
        },
        {
          name: 'twitter:image',
          content: this.twitterImage,
        },
        // 添加Open Graph相关元标签
        {
          property: 'og:url',
          content: `${baseUrl}${this.$route.fullPath}`,
        },
        {
          property: 'og:title',
          content: this.pageTitle || defaultTitle,
        },
        {
          property: 'og:description',
          content: this.pageDescription || this.$t('seo.description'),
        },
        {
          property: 'og:image',
          content: this.twitterImage,
        },
        // application-name
        {
          name: 'application-name',
          content: this.applicationName,
        },
      ],
    }
  },
}
